import { PageId } from 'constants/pages'

export const enum PageIdStylioCmp2 {
  AGE_CMP2 = PageId.AGE_CMP2,
  CURRENT_WARDROBE_CMP2 = PageId.CURRENT_WARDROBE_CMP2,
  URGE_1_CMP2 = PageId.URGE_1_CMP2,
  WARDROBE_GOAL_CMP2 = PageId.WARDROBE_GOAL_CMP2,
  HAIR_COLOR_CMP2 = PageId.HAIR_COLOR_CMP2,
  EYES_COLOR_CMP2 = PageId.EYES_COLOR_CMP2,
  SKIN_COLOR_CMP2 = PageId.SKIN_COLOR_CMP2,
  JEWELRY_CMP2 = PageId.JEWELRY_CMP2,
  COLOR_PALETTE_CMP2 = PageId.COLOR_PALETTE_CMP2,
  COLOR_HARMONY_CMP2 = PageId.COLOR_HARMONY_CMP2,
  URGE_6_CMP2 = PageId.URGE_6_CMP2,
  BODY_SHAPE_CMP2 = PageId.BODY_SHAPE_CMP2,
  TALL_CMP2 = PageId.TALL_CMP2,
  WEIGHT_CMP2 = PageId.WEIGHT_CMP2,
  URGE_5_CMP2 = PageId.URGE_5_CMP2,
  SHOPPING_CMP2 = PageId.SHOPPING_CMP2,
  STYLE_MOST_MATTERS_CMP2 = PageId.STYLE_MOST_MATTERS_CMP2,
  FEEL_ABOUT_CMP2 = PageId.FEEL_ABOUT_CMP2,
  URGE_2_CMP2 = PageId.URGE_2_CMP2,
  STYLE_COMPLIMENTS_CMP2 = PageId.STYLE_COMPLIMENTS_CMP2,
  PERCENTAGE_CMP2 = PageId.PERCENTAGE_CMP2,
  LIKE_OR_DISLIKE_CMP2 = PageId.LIKE_OR_DISLIKE_CMP2,
  LIKE_OR_DISLIKE_11_CMP2 = PageId.LIKE_OR_DISLIKE_11_CMP2,
  LIKE_OR_DISLIKE_12_CMP2 = PageId.LIKE_OR_DISLIKE_12_CMP2,
  LIKE_OR_DISLIKE_13_CMP2 = PageId.LIKE_OR_DISLIKE_13_CMP2,
  LIKE_OR_DISLIKE_14_CMP2 = PageId.LIKE_OR_DISLIKE_14_CMP2,
  LIKE_OR_DISLIKE_15_CMP2 = PageId.LIKE_OR_DISLIKE_15_CMP2,
  LIKE_OR_DISLIKE_16_CMP2 = PageId.LIKE_OR_DISLIKE_16_CMP2,
  LIKE_OR_DISLIKE_17_CMP2 = PageId.LIKE_OR_DISLIKE_17_CMP2,
  LIKE_OR_DISLIKE_18_CMP2 = PageId.LIKE_OR_DISLIKE_18_CMP2,
  LIKE_OR_DISLIKE_19_CMP2 = PageId.LIKE_OR_DISLIKE_19_CMP2,
  STYLES_FEEL_LIKE_YOU_CMP2 = PageId.STYLES_FEEL_LIKE_YOU_CMP2,
  URGE_8_CMP2 = PageId.URGE_8_CMP2,
  YOUR_LOCATION_CMP2 = PageId.YOUR_LOCATION_CMP2,
  WARDROBE_REFRESH_CMP2 = PageId.WARDROBE_REFRESH_CMP2,
  SEASON_CHANGE_CHALLENGES_CMP2 = PageId.SEASON_CHANGE_CHALLENGES_CMP2,
  LIFESTYLE_MATCH_CMP2 = PageId.LIFESTYLE_MATCH_CMP2,
  WEEKEND_ACTIVITIES_CMP2 = PageId.WEEKEND_ACTIVITIES_CMP2,
  OUTFIT_OCCASIONS_CMP2 = PageId.OUTFIT_OCCASIONS_CMP2,
  QUIZ_SUMMARY_CMP2 = PageId.QUIZ_SUMMARY_CMP2,
  BRAND_CMP2 = PageId.BRAND_CMP2,
  AVOID_COLORS_CMP2 = PageId.AVOID_COLORS_CMP2,
  AVOIDED_COLORS_CMP2 = PageId.AVOIDED_COLORS_CMP2,
  URGE_7_CMP2 = PageId.URGE_7_CMP2,
  FIND_NEW_CLOTHES_CMP2 = PageId.FIND_NEW_CLOTHES_CMP2,
  JACKET_COAT_BUDGET_CMP2 = PageId.JACKET_COAT_BUDGET_CMP2,
  TOP_BUDGET_CMP2 = PageId.TOP_BUDGET_CMP2,
  BOTTOM_BUDGET_CMP2 = PageId.BOTTOM_BUDGET_CMP2,
  SHOES_BUDGET_CMP2 = PageId.SHOES_BUDGET_CMP2,
  EXCITED_CAPSULE_PLAN_CMP2 = PageId.EXCITED_CAPSULE_PLAN_CMP2,
  URGE_3_CMP2 = PageId.URGE_3_CMP2,
  URGE_4_CMP2 = PageId.URGE_4_CMP2,
  BODY_SHAPE_CONFIDENCE_CMP2 = PageId.BODY_SHAPE_CONFIDENCE_CMP2,
  OUTFIT_ON_OTHERS_CMP2 = PageId.OUTFIT_ON_OTHERS_CMP2,
  DRAW_LESS_ATTENTION_CMP2 = PageId.DRAW_LESS_ATTENTION_CMP2,
  PREPARE_FLOW_CMP2 = PageId.PREPARE_FLOW_CMP2,
  EMAIL_CMP2 = PageId.EMAIL_CMP2,
  EMAIL_CONSENT_CMP2 = PageId.EMAIL_CONSENT_CMP2,
  SUBSCRIPTIONS_CMP2 = PageId.SUBSCRIPTIONS_CMP2,
  CANCEL_OFFER_CMP2 = PageId.CANCEL_OFFER_CMP2,
  SUB_UPSELL_CMP2 = PageId.SUB_UPSELL_CMP2,
  UPSELL_CMP2 = PageId.UPSELL_CMP2,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CMP2 = PageId.DOWNLOAD_CMP2,
}
